import { defaultTheme, ThemeType } from './defaultTheme'

export const theme = (): ThemeType => defaultTheme
